import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * HTTP 상태 코드를 보존하는 다운로드 에러. 호출부에서 404(영상 없음)와
 * 5xx(일시적 서버 오류 — 재시도 안내)를 구분해 안내할 수 있다.
 */
export class DownloadError extends Error {
  readonly status: number

  constructor(status: number) {
    super(`Download failed: ${status}`)
    this.name = 'DownloadError'
    this.status = status
  }
}

/**
 * 비디오를 다운로드한다. fetch+blob 방식으로 cross-origin에서도 작동.
 * @throws HTTP 에러 시 DownloadError, 네트워크 단절 시 fetch의 TypeError
 */
export async function downloadVideo(url: string, filename: string): Promise<void> {
  const response = await fetch(url)
  if (!response.ok) {
    throw new DownloadError(response.status)
  }

  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)

  const link = document.createElement("a")
  link.href = blobUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(blobUrl)
}
